import { plantSlides } from '../../domain/plants/plantMedia';

/**
 * Every lead picture in the deck, fetched up front (SPEC-025 D-28).
 *
 * The card behind renders its own, so the NEXT plant's picture is already
 * loading — but the one after it is not, and that is the one which has to be
 * ready the instant the deck advances. A plant whose picture arrives a beat late
 * is exactly the flicker this deck has been chasing, moved one card along.
 *
 * The whole category rather than a window of it: three to six plants, on a screen
 * whose entire purpose is those plants, at the band rung they will be drawn at.
 *
 * Taken from the habb.me pwa, which preloads its whole shortlist for the same
 * reason and found the reason first.
 */
export default function PlantDeckPreload({ deck }) {
    return (
        <div className="plant-deck__preload" aria-hidden="true" inert="">
            {deck.cards.map((card) => {
                const [lead] = plantSlides(card);

                return lead ? (
                    <img
                        key={card.id}
                        src={lead.src}
                        srcSet={lead.bandSrcSet ?? undefined}
                        sizes="(min-width: 640px) 640px, 100vw"
                        alt=""
                        loading="eager"
                        decoding="async"
                        draggable={false}
                    />
                ) : null;
            })}
        </div>
    );
}
